import { useContext } from 'react';
import { formContext } from '../../context';

/**
 * returns current form state
 */
export var useCreditCardState = function useCreditCardState() {
  return useContext(formContext).state;
};